"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../hooks");
var _net = require("../../../models/graphql-types/net");
var _SubCategory = require("./SubCategory");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const MobileSubLinksGenerator = ({
  subCategories
}) => {
  const isMobile = (0, _hooks.useIsMobile)();
  const [activeSubCategory, setActiveSubCategory] = (0, _react.useState)('');
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const handleSubCategoryClick = (0, _react.useCallback)(subCategory => {
    if (isMobile && subCategory === activeSubCategory) {
      setActiveSubCategory('');
    } else {
      setActiveSubCategory(subCategory);
    }
  }, [activeSubCategory, isMobile]);
  if (!subCategories) {
    return null;
  }

  /** What's new and All category links which are randomly ordered and have to be first on the list */
  const firstTwoItems = (0, _utils.getWhatsNewAndAllCategory)(subCategories);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MobileSubLinksRoot, {
    "data-testid": getTestId(_constants.MOBILE_SUBLINKS_ROOT),
    children: [firstTwoItems.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubCategory.SubCategory, {
      boldText: false,
      displayArrowIcon: false,
      subCategory: item,
      handleSubCategoryClick: handleSubCategoryClick,
      "data-testid": getTestId(_constants.SUBCATEGORY)
    }, item.linkType)), subCategories.map(subCategory => {
      // TODO -- Boolean(subCategory) - Temporary solution to filter out null values which is not included in type
      if (Boolean(subCategory) && subCategory.linkType === _net.NavigationLinkType.PopularBrands) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubCategory.SubCategory, {
          isBrands: true,
          subCategory: subCategory,
          activeSubCategory: activeSubCategory,
          handleSubCategoryClick: handleSubCategoryClick,
          "data-testid": getTestId(_constants.POPULAR_BRANDS)
        }, subCategory.url);
      }

      // TODO -- Boolean(subCategory) - Temporary solution to filter out null values which is not included in type
      if (Boolean(subCategory) && subCategory.linkType === _net.NavigationLinkType.SubCategory) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubCategory.SubCategory, {
          subCategory: subCategory,
          activeSubCategory: activeSubCategory,
          handleSubCategoryClick: handleSubCategoryClick,
          "data-testid": getTestId(_constants.SUBCATEGORY),
          displayArrowIcon: subCategory.children.length > 0
        }, subCategory.url);
      }
      return null;
    })]
  });
};
var _default = exports.default = MobileSubLinksGenerator;